import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ControlPresente = ({ fechaPasada }) => {
  const [docentesDia, setDocentesDia] = useState([]);
  const [huellas, setHuellas] = useState(new Set());

  function obtenerDiaSemana(fechaString) {
    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const fechaArgentina = new Date(
      new Date(fechaString + "T00:00:00").toLocaleString("en-US", {
        timeZone: "America/Argentina/Buenos_Aires",
      })
    );
    return diasSemana[fechaArgentina.getDay()];
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const diaSemana = obtenerDiaSemana(fechaPasada);

        const [resHuellas, resDocentes] = await Promise.all([
          axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/docentes/getHuellasPorFecha",
            { fecha: fechaPasada }
          ),
          axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/docentes/devuelveDocentesDiaSemana",
            { dia: diaSemana }
          ),
        ]);

        const docentesOrdenados = resDocentes.data
          .map((docente) => ({
            dni: docente.docenteDni,
            apellido: docente.plantelDocente?.docenteApellido || "",
            nombre: docente.plantelDocente?.docenteNombres || "",
          }))
          .sort((a, b) => {
            const fullNameA = `${a.apellido} ${a.nombre}`.toLowerCase();
            const fullNameB = `${b.apellido} ${b.nombre}`.toLowerCase();
            return fullNameA.localeCompare(fullNameB);
          });

        const dnisConHuella = new Set(resHuellas.data.map((d) => d.docenteDni));

        setDocentesDia(docentesOrdenados);
        setHuellas(dnisConHuella);
      } catch (error) {
        console.error("Error al cargar los datos", error);
      }
    };

    fetchData();
  }, [fechaPasada]);

 const exportarExcel = () => {
  const data = docentesDia.map((docente, index) => ({
    Nro: index + 1,
    Apellido: docente.apellido,
    Nombre: docente.nombre,
    DNI: docente.dni,
    Estado: huellas.has(docente.dni) ? "Marco" : "No Marco",
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Listado");

  const fechaArchivo = fechaPasada.replace(/-/g, "_");
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" }); 
  const blob = new Blob([wbout], { type: "application/octet-stream" });
  saveAs(blob, `Control_Presente_${fechaArchivo}.xlsx`);
};


  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">
        Control de Presente - {fechaPasada} - ({obtenerDiaSemana(fechaPasada)})
      </h2>

      <button
        onClick={exportarExcel}
        className="btn btn-success"
      >
        Descargar Excel
      </button>

      <ul className="space-y-2">
        {docentesDia.map((docente, index) => {
          const presente = huellas.has(docente.dni);
          const color = presente ? "green" : "red";
          const estadoTexto = presente ? "Marco" : "No Marco";

          return (
            <li
              key={docente.dni}
              style={{
                color,
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "10px",
                backgroundColor: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <span>
                <strong>{index + 1}.</strong> {docente.apellido}, {docente.nombre}
              </span>
              <span style={{ fontWeight: "600" }}>{estadoTexto}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ControlPresente;
